import React from 'react';
import { Zap, Brain, Check } from 'lucide-react';

const ModeSelector = ({ mode, setMode, subscription }) => {
  const plan = subscription?.plan || 'free';
  const canUseDeep = plan === 'plus' || plan === 'pro';

  return (
    <div className="bg-neutral-charcoal border border-accent-teal/20 rounded-lg p-4 mb-6">
      <label className="block text-white font-semibold text-sm mb-3">
        Generation Mode
      </label>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {/* BASIC */}
        <button
          type="button"
          onClick={() => setMode('basic')}
          className={`relative flex items-start gap-3 p-4 rounded-lg border-2 transition-all text-left
            ${mode === 'basic'
              ? 'border-accent-teal bg-accent-teal/10 ring-2 ring-accent-teal/30'
              : 'border-neutral-dark bg-neutral-dark hover:border-accent-teal/40'}`}
        >
          {mode === 'basic' && (
            <div className="absolute top-2 right-2 w-5 h-5 rounded-full bg-accent-teal flex items-center justify-center">
              <Check size={12} className="text-white" />
            </div>
          )}
          <Zap size={20} className="text-accent-teal" />
          <div>
            <div className="font-semibold text-white">Basic Mode</div>
            <p className="text-xs text-neutral-silver">
              Quick generation with standard AI processing
            </p>
          </div>
        </button>

        {/* DEEP */}
        <button
          type="button"
          onClick={() => canUseDeep && setMode('deep')}
          disabled={!canUseDeep}
          className={`relative flex items-start gap-3 p-4 rounded-lg border-2 transition-all text-left
            ${!canUseDeep ? 'opacity-60 cursor-not-allowed' : ''}
            ${mode === 'deep' && canUseDeep
              ? 'border-accent-purple bg-accent-purple/15 ring-2 ring-accent-purple/30'
              : 'border-neutral-dark bg-neutral-dark hover:border-accent-purple/40'}`}
        >
          {mode === 'deep' && canUseDeep && (
            <div className="absolute top-2 right-2 w-5 h-5 rounded-full bg-accent-purple flex items-center justify-center">
              <Check size={12} className="text-white" />
            </div>
          )}
          <Brain size={20} className="text-accent-purple" />
          <div>
            <div className="font-semibold text-white">Deep Research</div>
            <p className="text-xs text-neutral-silver">
              Enhanced AI with deeper analysis & research (monthly quota)
            </p>
            {!canUseDeep && (
              <p className="text-xs text-yellow-500 mt-2">
                ⭐ Upgrade to Plus or Pro to unlock
              </p>
            )}
          </div>
        </button>
      </div>

      <div className="mt-3 text-center text-xs text-neutral-silver">
        Currently selected:{' '}
        <span className={`font-semibold ${mode === 'basic'
          ? 'text-accent-teal'
          : 'text-accent-purple'}`}>
          {mode === 'basic' ? 'Basic Mode' : 'Deep Research'}
        </span>
      </div>
    </div>
  );
};

export default ModeSelector;
